// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"src/styles/variables/colors.css\"","white":"#ffffff","ArrowContainer":"styles-module--ArrowContainer--2BE1r","bounce":"styles-module--bounce--3uQse"};